import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const namespaced = true;

const trainingWalkThroughModule = {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};

export default trainingWalkThroughModule;
